import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { navigation: Boolean, skills: Boolean, skillPath: String };
  declare readonly skillPathValue: string;
  declare readonly skillsValue: boolean;
  declare readonly navigationValue: boolean;

  // The panel stamps aria-expanded on every launcher when it opens or closes,
  // but a launcher re-rendered by a Turbo stream arrives with the markup's
  // "false"; reading the panel's own state on connect heals that.
  connect(): void {
    const panelId = this.element.getAttribute("aria-controls");
    const panel = panelId ? document.getElementById(panelId) : null;
    if (panel) this.element.setAttribute("aria-expanded", String(!panel.hidden));
  }

  open(): void {
    this.dispatch("open", { prefix: "assistant", target: window, detail: { navigation: this.navigationValue, skills: this.skillsValue, skillPath: this.skillPathValue } });
  }

  toggle(): void {
    this.dispatch("toggle", { prefix: "assistant", target: window });
  }
}
